import * as React from "react";
import { forwardRef } from "react";
const SvgDotsOrangeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 30, viewBox: "0 0 12 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("ellipse", { cx: 6, cy: 6, rx: 6, ry: 6, fill: "#FF6400" }), /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 24, r: 6, fill: "#FF6400" }));
const ForwardRef = forwardRef(SvgDotsOrangeIcon);
export { ForwardRef as ReactComponent };
